import { faInstagram, faXTwitter, faFacebookF, faLinkedinIn, faGithub } from '@fortawesome/free-brands-svg-icons';
import { InputText, InputDescription, InputSocialMedia, PassBtn } from '../../../_imports';
import './personal_form.css';

function DadosPessoaisStep({ formData, handleChange, nextStep, handleRedesSociaisChange, errors = {} }) {
  return (
    <fieldset>
      <legend>Dados Pessoais</legend>

      <InputText
        label="Nome Completo:"
        id="nome"
        name="nome"
        dataSection="dadosPessoais"
        value={formData.nome}
        onChange={handleChange}
        required={true}
        placeholder="Nome Sobrenome"
        error={errors.nome}
      />
      <div className='sized-box'></div>
      <InputText
        label="CPF:"
        id="cpf"
        name="cpf"
        dataSection="dadosPessoais"
        value={formData.cpf}
        onChange={handleChange}
        required={true}
        placeholder="000.000.000-00"
        error={errors.cpf}
      />
      <div className='sized-box'></div>
      <InputText
        label="E-mail:"
        id="email"
        name="email"
        type="email"
        dataSection="dadosPessoais"
        value={formData.email}
        onChange={handleChange}
        required={true}
        placeholder="meuemail@email.com"
        error={errors.email}
      />
      <div className='sized-box'></div>
      <div className="LinhaCampos">
        <InputText
          label="Município:"
          id="municipio"
          name="municipio"
          dataSection="dadosPessoais"
          value={formData.municipio}
          onChange={handleChange}
          placeholder="Francisco Beltrão"
          error={errors.municipio}
        />
        <div className='sized-box'></div>
        <InputText
          label="Bairro:"
          id="bairro"
          name="bairro"
          dataSection="dadosPessoais"
          value={formData.bairro}
          onChange={handleChange}
          placeholder="Meu Bairro"
          error={errors.bairro}
        />
      </div>

      <InputText
        label="Telefone:"
        id="telefone"
        name="telefone"
        type="tel"
        dataSection="dadosPessoais"
        value={formData.telefone}
        onChange={handleChange}
        placeholder="(XX) XXXXX-XXXX"
        error={errors.telefone}
      />
      <div className='sized-box'></div>
      <InputDescription
        label="Sobre mim:"
        id="sobreMim"
        name="sobreMim"
        dataSection="dadosPessoais"
        value={formData.sobreMim}
        onChange={handleChange}
        rows={4}
        placeholder="Fale um pouco sobre você..."
      />
      <div className='sized-box'></div>
      <div className="Campo">
        <label>Redes Sociais: (Opcional)</label>

        <InputSocialMedia
          icon={faInstagram}
          name="instagram"
          placeholder="@ do Instagram"
          dataSection="dadosPessoais"
          dataSubsection="redesSociais"
          value={formData.redesSociais.instagram}
          onChange={handleRedesSociaisChange}
        />
        <div className='sized-box'></div>
        <InputSocialMedia
          icon={faXTwitter}
          name="x"
          placeholder="@ do X (Twitter)"
          dataSection="dadosPessoais"
          dataSubsection="redesSociais"
          value={formData.redesSociais.x}
          onChange={handleRedesSociaisChange}
        />
        <div className='sized-box'></div>
        <InputSocialMedia
          icon={faFacebookF}
          name="facebook"
          placeholder="Nome do Facebook"
          dataSection="dadosPessoais"
          dataSubsection="redesSociais"
          value={formData.redesSociais.facebook}
          onChange={handleRedesSociaisChange}
        />
        <div className='sized-box'></div>
        <InputSocialMedia
          icon={faLinkedinIn}
          name="linkedin"
          placeholder="Link do LinkedIn"
          dataSection="dadosPessoais"
          dataSubsection="redesSociais"
          value={formData.redesSociais.linkedin}
          onChange={handleRedesSociaisChange}
        />
        <div className='sized-box'></div>
        <InputSocialMedia
          icon={faGithub}
          name="github"
          placeholder="@ do GitHub"
          dataSection="dadosPessoais"
          dataSubsection="redesSociais"
          value={formData.redesSociais.github}
          onChange={handleRedesSociaisChange}
        />
      </div>

      <div className="BotoesNavegacao">
        <PassBtn text="Próximo" onClick={nextStep} direction="next" />
      </div>
    </fieldset>
  );
}

export default DadosPessoaisStep;